module.exports = __webpack_public_path__ + "img/membership-management.76f6217c.svg";